/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GuardrailConfig,
  GuardrailConfig$inboundSchema,
  GuardrailConfig$Outbound,
  GuardrailConfig$outboundSchema,
} from "./guardrailconfig.js";

export type UpdateGuardrailsResponse = {
  object: "guardrails_settings";
  guardrails: Array<GuardrailConfig>;
  /**
   * Team this policy targets; null for the org-wide policy
   */
  teamId: string | null;
  /**
   * Unix timestamp of when the policy was updated
   */
  updatedAt: number;
};

/** @internal */
export const UpdateGuardrailsResponse$inboundSchema: z.ZodType<
  UpdateGuardrailsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("guardrails_settings"),
  guardrails: z.array(GuardrailConfig$inboundSchema),
  team_id: z.nullable(z.string()),
  updated_at: z.number(),
}).transform((v) => {
  return remap$(v, {
    "team_id": "teamId",
    "updated_at": "updatedAt",
  });
});
/** @internal */
export type UpdateGuardrailsResponse$Outbound = {
  object: "guardrails_settings";
  guardrails: Array<GuardrailConfig$Outbound>;
  team_id: string | null;
  updated_at: number;
};

/** @internal */
export const UpdateGuardrailsResponse$outboundSchema: z.ZodType<
  UpdateGuardrailsResponse$Outbound,
  z.ZodTypeDef,
  UpdateGuardrailsResponse
> = z.object({
  object: z.literal("guardrails_settings"),
  guardrails: z.array(GuardrailConfig$outboundSchema),
  teamId: z.nullable(z.string()),
  updatedAt: z.number(),
}).transform((v) => {
  return remap$(v, {
    teamId: "team_id",
    updatedAt: "updated_at",
  });
});

export function updateGuardrailsResponseToJSON(
  updateGuardrailsResponse: UpdateGuardrailsResponse,
): string {
  return JSON.stringify(
    UpdateGuardrailsResponse$outboundSchema.parse(updateGuardrailsResponse),
  );
}
export function updateGuardrailsResponseFromJSON(
  jsonString: string,
): SafeParseResult<UpdateGuardrailsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpdateGuardrailsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpdateGuardrailsResponse' from JSON`,
  );
}
